<main class="mb-4">
  <div class="row ">
    <div class="col-sm-12">
      <h2 class="text-primary mb-3">{{'PrestacoesMorte.StepSender.Cards.SenderObservations.Title' | translate}}</h2>
    </div>
  </div>
  <div class="row">
    <!--Observações-->
    <div class="col-sm-12">
      <label for="observations">{{'PrestacoesMorte.StepSender.Cards.SenderObservations.Fields.AdditionalObservations' | translate}}</label>
      <div class="position-relative">
        <textarea class="form-control input-right" rows="6" type="text" [(ngModel)]="cardData.additionalObservations"
                  #additionalObservations="ngModel" name="additionalObservations"
                  [maxLength]="300"
                  placeholder="{{'PrestacoesMorte.StepSender.Cards.SenderObservations.Fields.AdditionalObservationsPlaceholder' | translate}}"
                  messageFieldType="string"></textarea>
      </div>
    </div>
  </div>
</main>
